import { memo, useEffect } from 'react';
import { IBaseProps } from 'src/types/common.type';
import { onMessageListener, requestPermissionNotification } from 'src/utils/firebase';
import MESSAGE from 'src/utils/message';

function NotificationProvider({ children }: IBaseProps) {
  useEffect(() => {
    // Gọi hàm xin quyền và lấy token ngay khi vào app
    const setupNotifications = () => {
      requestPermissionNotification();
    };

    setupNotifications();

    // Lắng nghe thông báo khi user đang mở web
    const unsubscribe = async () => {
      const a = await onMessageListener();
      // alert(a.notification?.body);
      MESSAGE.warning(`${a.notification?.title}: ${a.notification?.body}`);
    };

    unsubscribe();

    // return () => unsubscribe && unsubscribe();
  }, []);

  return children;
}

export default memo(NotificationProvider);
